/**
 * Module-private флаг, временно разрешающий подписки на потоки во время серверного рендера.
 *
 * Используется только внутренней инфраструктурой потоков. Включается на время синхронных вызовов
 * `subscribe(...)` в `FlowComputationBase.subscribeToSources` и в `asPromise()`. Подписка
 * вычисляемого потока на свои источники — это инфраструктурный вызов, не пользовательский,
 * поэтому SSR-проверку для него нужно пропускать.
 */
let bypassEnabled = false;

/**
 * Запускает `fn` с поднятым флагом bypass — внутри блока вызовы `flow.subscribe(...)` не падают
 * на сервере. По выходу из блока флаг возвращается в исходное состояние (поддерживает вложенные
 * блоки корректно).
 */
export function withBypassSsr<T>(fn: () => T): T {
    const prev = bypassEnabled;
    bypassEnabled = true;
    try {
        return fn();
    } finally {
        bypassEnabled = prev;
    }
}

/**
 * Проверяет, поднят ли флаг bypass в текущем синхронном контексте вызова.
 */
export function isBypassSsr(): boolean {
    return bypassEnabled;
}
